let widthWrap = 0 // 每三格R变成0
class DoProductStyleCalc {
  initWidthWrap () {
    widthWrap = 0
  }
  handleItemWidth (item): {itemWidth: string; itemMarginRight: string; size: number} {
    let itemWidth: string = ''
    let itemMarginRight: string = ''
    let size: number = 0
    if (!item.name) {
      return { itemWidth: '0px', itemMarginRight: '0px', size: 0 }
    }
    const sbsLen = item.name.zhLength()
    if (sbsLen <= 7) {
      itemWidth = '32.56%'
      widthWrap += 1
      size = 1
    } else if (sbsLen > 7 && sbsLen <= 14) {
      itemWidth = '65.12%'
      widthWrap += 2
      size = 2
    } else {
      itemWidth = '100%'
      widthWrap += 3
      size = 3
    }
    if (widthWrap >= 3) {
      if (widthWrap === 3) {
        itemMarginRight = '0'
      }
      widthWrap = 0
    }
    return { itemWidth, size, itemMarginRight }
  }
  handleModifyStyle (data) {
    const modifyStyle: any = {}
    data.map(groups => {
      const groupRow = []
      let groupRowIndex = 0
      let initSize = 0
      groups.modifiers.map((modify, index) => {
        const { itemWidth, itemMarginRight, size } = this.handleItemWidth(modify)
        modifyStyle[modify.no] = { itemWidth, itemMarginRight }
        if (!groupRow[groupRowIndex]) {
          initSize += size
          groupRow[groupRowIndex] = {
            indexList: [],
            hasPrice: !!modify.price
          }
          groupRow[groupRowIndex].indexList.push(index)
        } else {
          if (initSize + size > 3) {
            initSize = 0
            groupRowIndex += 1
            groupRow[groupRowIndex] = {
              indexList: [],
              hasPrice: !!modify.price
            }
          }
          if (!groupRow[groupRowIndex].hasPrice) {
            groupRow[groupRowIndex].hasPrice = !!modify.price
          }
          initSize += size
          groupRow[groupRowIndex].indexList.push(index)
        }
      })
      groups.modifiers.map((modify, index) => {
        const hasModifyPrice = groupRow.find(item => {
          const _item = item.indexList.find(v => v === index)
          if (_item || _item === 0) {
            return item
          }
        })
        if (hasModifyPrice && hasModifyPrice.hasPrice) {
          modifyStyle[modify.no] = { ...modifyStyle[modify.no], itemHeight: '56px' }
        } else {
          modifyStyle[modify.no] = { ...modifyStyle[modify.no], itemHeight: '48px' }
        }
      })
    })
    return modifyStyle
  }
}

export default new DoProductStyleCalc()
